import { UserService } from '@/api/user'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { useContext, useEffect } from 'react'

// eslint-disable-next-line react-refresh/only-export-components
export const specCurrentProfile = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Profile',
    name: 'profile',
    type: 'text',
  },
]

export default function CurrentProfile() {
  const { setValue } = useContext<CustomComponentContextType>(CustomComponentContext)
  const { data: userData } = UserService.useGetProfile()

  useEffect(() => {
    if (userData) {
      setValue('profile', userData)
    }
  }, [userData, setValue])

  return <></>
}
